function render(element) {
  console.warn(`empty`);
}
export {
  render
};
//# sourceMappingURL=render.native.js.map
